import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('optgroup');

const HEADER_ID = 'header-id';

export { TAG_NAME, HEADER_ID };
